module.exports = __webpack_public_path__ + "img/dirty-icon.dd9887b2.svg";